import { TextInput } from '@mantine/core';
import { last } from 'lodash';
import React from 'react';

const B2BInput = ({ value, className,style, styles, edit, onChange, placeholder, variant, required, error, type, radius, disabled, rightSection, label, withAsterisk }) => {
    return (
        <TextInput
            className={className}
            label={label}
            styles={{ input: { fontSize: '14px', cursor: edit === true ? 'not-allowed' : 'text', ...styles?.input } }}
            placeholder={placeholder}
            style={style}
            value={value}
            type={type}
            variant={variant}
            required={required}
            size='md'
            radius={radius || "sm"}
            autoComplete='new-password'
            disabled={disabled}
            onChange={onChange}
            error={error}
            rightSection={rightSection}
            withAsterisk={withAsterisk}
        />
    );
}

export default B2BInput;